import { useState } from 'react';

export default function FAQSection() {
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const toggleFaq = (index: number) => setOpenFaq(openFaq === index ? null : index);

  const faqs = [
    {
      question: 'Кто проводит обучение в Business Training?',
      answer: 'Все программы проводит лично Алексей Сивко — практикующий бизнес-тренер с опытом более 18 лет в корпоративных продажах, переговорах и управлении. Автор концепции «Культурология продаж». За плечами — 11 лет работы в Профессиональных Правовых Системах, где он прошёл путь от менеджера по продажам до руководителя учебного центра, и более 100 корпоративных проектов в качестве бизнес-тренера и консультанта.'
    },
    {
      question: 'Какой опыт у тренера?',
      answer: 'Более 18 лет практики в продажах и переговорах. 100+ корпоративных проектов, 450+ тренингов и стратегических сессий, 4500+ участников. Опыт работы с компаниями из Беларуси, России, Казахстана и Израиля в отраслях: логистика, IT, недвижимость, производство, финансы, медицина, строительство, образование и услуги. 11 лет в корпоративной среде — от рядового менеджера до руководителя учебного центра.'
    },
    {
      question: 'Можно ли адаптировать программу под специфику компании?',
      answer: 'Да, это ключевой принцип работы. Каждая программа разрабатывается индивидуально после диагностики: изучение бизнес-процессов, интервью с руководителями, анализ реальных переговоров и KPI. Программа адаптируется под специфику отрасли, продукта, цикла продаж, уровня подготовки сотрудников и конкретных бизнес-задач. Никаких шаблонных решений.'
    },
    {
      question: 'Работаете ли вы онлайн?',
      answer: 'Да, корпоративные тренинги проводятся как очно в Минске и Беларуси, так и онлайн для команд из России, Казахстана, Узбекистана и Израиля. Онлайн-формат включает интерактивные инструменты, разбор реальных кейсов, ролевые игры и практические задания. При правильной организации эффективность онлайн-обучения не уступает очному формату.'
    },
    {
      question: 'Есть ли сопровождение после тренинга?',
      answer: 'Да, посттренинговое сопровождение — обязательная часть системного подхода. Оно включает: регулярные встречи с руководителем (раз в 1-2 недели), выборочный аудит работы сотрудников, разбор кейсов в Telegram, домашние задания с обратной связью, корректировку инструментов и контроль внедрения. Длительность сопровождения — от 1 до 6 месяцев в зависимости от масштаба проекта и поставленных целей.'
    },
    {
      question: 'Как проходит диагностика перед обучением?',
      answer: 'Диагностика включает несколько этапов: интервью с руководителем и ключевыми сотрудниками, анализ бизнес-процессов и воронки продаж, прослушивание реальных звонков (обычно 20-40 звонков), анализ переписок с клиентами, изучение текущих KPI и точек падения конверсии, наблюдение за работой отдела (при очном формате). На основе диагностики формируется индивидуальная программа с измеримыми целями.'
    },
    {
      question: 'Сколько корпоративных проектов реализовано?',
      answer: 'Реализовано более 100 корпоративных проектов. Проведено 450+ тренингов и стратегических сессий, обучено 4500+ участников. Среди клиентов — компании из логистики, IT, недвижимости, производства, финансов, медицины, строительства, образования и сферы услуг. География проектов: Беларусь, Россия, Казахстан, Узбекистан, Израиль.'
    },
    {
      question: 'С какими компаниями работает Алексей Сивко?',
      answer: 'Алексей работает с компаниями из сфер B2B и B2C: логистика и перевозки, IT и разработка ПО, недвижимость и девелопмент, производство, финансовые услуги и страхование, медицина и фармацевтика, строительство, образование и EdTech, розничная и оптовая торговля, сфера услуг. Программы адаптируются под специфику отрасли, размер компании и уровень подготовки сотрудников.'
    },
    {
      question: 'В чём отличие вашего подхода от других бизнес-тренеров?',
      answer: 'Ключевые отличия: 1) глубокая предварительная диагностика — не «приехал и провёл», а сначала изучил бизнес; 2) 18+ лет личного опыта в продажах — не теоретик, а практик; 3) работа с реальными кейсами компании — не абстрактные примеры; 4) 80% практики; 5) создание инструментов, которые остаются в компании (скрипты, регламенты, книги продаж); 6) долгосрочное сопровождение после тренинга; 7) измеримый результат в KPI бизнеса.'
    },
    {
      question: 'Как измерить эффективность работы с вами?',
      answer: 'Эффективность измеряется по конкретным бизнес-показателям: рост конверсии на каждом этапе воронки, увеличение среднего чека, снижение процента скидок, рост повторных продаж, сокращение цикла сделки, снижение текучести кадров. Мы фиксируем исходные показатели до начала работы, делаем промежуточные замеры и готовим итоговый отчёт с динамикой всех KPI.'
    }
  ];

  return (
    <section id="faq" className="py-20 md:py-28 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Часто задаваемые вопросы
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Ответы на вопросы, которые чаще всего задают руководители перед началом сотрудничества.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-gray-50 rounded-xl overflow-hidden">
              <button
                onClick={() => toggleFaq(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <h3 className="text-base md:text-lg font-semibold text-gray-900 pr-4">{faq.question}</h3>
                <div className="w-8 h-8 bg-teal-100 rounded-full flex items-center justify-center flex-shrink-0">
                  {openFaq === index ? (
                    <i className="ri-arrow-up-s-line text-teal-600"></i>
                  ) : (
                    <i className="ri-arrow-down-s-line text-teal-600"></i>
                  )}
                </div>
              </button>
              <div className={`px-6 pb-6 ${openFaq === index ? '' : 'hidden'}`}>
                <p className="text-gray-600 leading-relaxed text-sm md:text-base">{faq.answer}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}